module.exports = __webpack_public_path__ + "static/media/icon_transferencia_al_exterior.fa18ea20.svg";